import { render, staticRenderFns } from "./AnnotationAssessmentScoreCard.vue?vue&type=template&id=fc1ba9d8&scoped=true"
import script from "./AnnotationAssessmentScoreCard.vue?vue&type=script&lang=ts"
export * from "./AnnotationAssessmentScoreCard.vue?vue&type=script&lang=ts"
import style0 from "./AnnotationAssessmentScoreCard.vue?vue&type=style&index=0&id=fc1ba9d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc1ba9d8",
  null
  
)

export default component.exports